export default [
    {
        path: '/ai/chat-bot',
        name: 'chat-bot',
        component: () => import('@/views/ai-bot/chat-bot/ChatBotList.vue'),
        meta: {
            resource: 'ai-bot',
            action: 'read',
        },

    },
    {
        path: '/ai/web-chat',
        name: 'web-chat',
        component: () => import('@/views/ai-bot/chat-bot/WebChatHistory.vue'),
        meta: {
            resource: 'ai-bot',
            action: 'read',
        },
    },
    {
        path: '/ai/leads',
        name: 'ai-leads',
        component: () => import('@/views/ai-bot/chat-bot/LeadsList.vue'),
        meta: {
            resource: 'ai-bot',
            action: 'read',
        },
    },
    {
        path: '/ai/voice-bot',
        name: 'voice-bot',
        component: () => import('@/views/ai-bot/voice-bot/VoiceBotList.vue'),
        meta: {
            resource: 'ai-bot',
            action: 'read',
        },
        
    },
]